export var defaultFontWeightOptions = {
  ultralight: 200,
  light: 300,
  regular: 400,
  medium: 500,
  bold: 700
};
// Collection of themes with unique font weights.
var fontInfo = [{
  fontName: 'Montserrat',
  fontWeightOptions: {
    ultralight: 400,
    light: 400,
    regular: 400,
    medium: 400,
    bold: 700
  }
}, {
  fontName: 'Open Sans Condensed',
  fontWeightOptions: {
    ultralight: 300,
    light: 300,
    regular: 300,
    medium: 300,
    bold: 700
  }
}];
var getFontWeights = function getFontWeights() {
  var fontFamily = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var fontItem = fontInfo.find(function (t) {
    return t.fontName === fontFamily.split(',')[0];
  });
  return fontItem ? fontItem.fontWeightOptions : defaultFontWeightOptions;
};
export default getFontWeights;
//# sourceMappingURL=getFontWeights.js.map